import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";

export const msalInstance = new PublicClientApplication(msalConfig);

const MICROSOFT_LOGIN_IN_PROGRESS = "atlantis.microsoft.login.inProgress";

let initializePromise = null;
let redirectPromise = null;

const getSafeStoragePreview = (value) => {
  const rawValue = String(value || "");

  if (
    rawValue.includes("code=") ||
    rawValue.includes('"code"') ||
    rawValue.includes("id_token") ||
    rawValue.includes("access_token")
  ) {
    return "[redacted auth response]";
  }

  return rawValue.slice(0, 160);
};

const getMsalDebugStorage = () => {
  if (typeof window === "undefined") return [];

  const collect = (storage, storageName) =>
    Object.keys(storage)
      .filter((key) => key.toLowerCase().includes("msal"))
      .map((key) => ({
        storage: storageName,
        key,
        valuePreview: getSafeStoragePreview(storage.getItem(key)),
      }));

  return [
    ...collect(window.sessionStorage, "sessionStorage"),
    ...collect(window.localStorage, "localStorage"),
  ];
};

const storageTargets = () => {
  if (typeof window === "undefined") return [];
  return [window.sessionStorage, window.localStorage].filter(Boolean);
};

const isMsalInteractionKey = (key) =>
  key === "msal.interaction.status" ||
  key.endsWith(".interaction.status") ||
  key.includes("interaction.status");

export const initializeMsal = async () => {
  if (!initializePromise) {
    initializePromise = msalInstance.initialize();
  }

  return initializePromise;
};

export const handleMsalRedirect = async () => {
  await initializeMsal();

  if (!redirectPromise) {
    const urlParams = new URLSearchParams(window.location.search);
    const hashParams = new URLSearchParams(window.location.hash.replace(/^#/, ""));



    redirectPromise = msalInstance
      .handleRedirectPromise({ navigateToLoginRequestUrl: false })
      .then((response) => {
        

        return response;
      })
      .catch((err) => {
        console.error("[MSAL Redirect] handleRedirectPromise ERROR", err);
        throw err;
      })
      .finally(() => {
    sessionStorage.removeItem(MICROSOFT_LOGIN_IN_PROGRESS);
    redirectPromise = null;
});
      // .finally(() => {
      //   sessionStorage.removeItem(MICROSOFT_LOGIN_IN_PROGRESS);
      // });
  } else {
   
  }

  return redirectPromise;
};
export const clearMsalInteractionState = () => {
  storageTargets().forEach((storage) => {
    Object.keys(storage).forEach((key) => {
      if (isMsalInteractionKey(key)) {
        storage.removeItem(key);
      }
    });
  });
  sessionStorage.removeItem(MICROSOFT_LOGIN_IN_PROGRESS);
};

export const markMicrosoftLoginStarted = () => {
  sessionStorage.setItem(MICROSOFT_LOGIN_IN_PROGRESS, "true");
};

export const hasMicrosoftLoginInProgress = () => {
  if (sessionStorage.getItem(MICROSOFT_LOGIN_IN_PROGRESS) === "true") {
    return true;
  }

  return storageTargets().some((storage) =>
    Object.keys(storage).some((key) => isMsalInteractionKey(key))
  );
};

export const getMicrosoftAuthErrorMessage = (error) => {
  const message = error?.message || "";

  if (message.includes("AADSTS9002326") || message.includes("9002326")) {
    return "Microsoft login is not configured as a Single-page application in Azure. Add this app's redirect URI under Azure App Registration > Authentication > Single-page application.";
  }

  if (error?.errorCode === "interaction_in_progress" || message.includes("interaction_in_progress")) {
    return "A Microsoft login was already in progress. Please try again.";
  }

  return message || "Microsoft login failed. Please try again.";
};
